import React, {useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';

import './index.style.less';
import {AiOutlineMail} from 'react-icons/ai';
import {Button, Dropdown, List, Menu, message, notification} from 'antd';
import AppScrollbar from '../AppScrollbar';
import MessageItem from './MessageItem';
import {useAuthUser} from '../../utility/AuthHooks';
import IntlMessages from '../../utility/IntlMessages';
import {findMessages} from 'services/MessageService';
import {SYSTEM_AVATAR_URL} from 'shared/constants/AppConst';
import {handleError} from 'utils/MessageUtils';
import {useSubscription} from 'react-stomp-hooks';

const AppHeaderMessages = () => {
  const {user: loggedUser} = useAuthUser();
  const {keycloak} = useKeycloak();
  const intl = useIntl();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const [messages, setMessages] = useState([]);

  useSubscription('/user/queue/system-messages', () => {
    loadData();
    notification['info']({
      message: intl.messages['common.notifications'],
      description: intl.messages['common.newMessage'],
    });
  });

  const loadData = () => {
    findMessages(headers, {
      pagination: {
        current: 1,
        pageSize: 10,
      },
      filters: [
        {
          field: 'receiverId',
          value: loggedUser?.id,
        },
      ],
      sorters: [
        {
          field: 'createdDate',
          order: 'desc',
        },
      ],
    })
      .then((res) => {
        setMessages(
          res.data.map((item) => {
            return {
              id: item.id,
              image: SYSTEM_AVATAR_URL,
              name: intl.messages['app.name'],
              message: item.content,
              time: item.createdDate,
            };
          }),
        );
      })
      .catch((error) => handleError(message, error));
  };

  useEffect(() => {
    loadData();
  }, [loggedUser]);

  const menu = (
    <Menu className='header-message'>
      <Menu.Item className='header'>
        <IntlMessages id='common.messages' /> ({messages.length})
      </Menu.Item>
      <Menu.Item>
        <AppScrollbar className='header-message-scroll-submenu'>
          <List
            dataSource={messages}
            renderItem={(item) => {
              return <MessageItem key={item.id} item={item} />;
            }}
          />
        </AppScrollbar>
      </Menu.Item>
      <Menu.Item>
        <Button className='header-message-btn' type='primary'>
          <IntlMessages id='common.viewAll' />
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu} trigger={['click']}>
        <a className='header-message-link' onClick={(e) => e.preventDefault()}>
          <span className='header-message-icon'>
            <AiOutlineMail />
          </span>
          <span className='header-message-link-text'>
            <IntlMessages id='common.messages' />
          </span>
        </a>
      </Dropdown>
    </>
  );
};

export default AppHeaderMessages;
